import * as React from 'react';

interface LoaderSizeProps {
  loading?: boolean;
  color?: string;
  speedMultiplier?: number;
  cssOverride?: React.CSSProperties;
  size?: number | string;
}

const BounceLoader = ({
  loading = true,
  speedMultiplier = 1,
  size = 60,
  cssOverride = {},
  color = '#7500C0',
  ...additionalprops
}: LoaderSizeProps): JSX.Element | null => {
  if (!loading) {
    return null;
  }

  // Generate style properties based on the props
  const wrapperStyle: React.CSSProperties = {
    width: typeof size === 'number' ? `${size}px` : size,
    height: typeof size === 'number' ? `${size}px` : size,
    ...cssOverride,
  };

  const dotStyle: React.CSSProperties = {
    width: typeof size === 'number' ? `${size}px` : size,
    height: typeof size === 'number' ? `${size}px` : size,
    backgroundColor: color,
  };

  return (
    <span className="bounce-loader" style={wrapperStyle} {...additionalprops}>
      <div style={dotStyle} />
      <div style={dotStyle} />
    </span>
  );
};

export default BounceLoader;
